import type { Capability } from '@taler/api-client'

/**
 * The contract's `Capability` enum has no `LOAN_*` entry. A loan is a financial record
 * like a contact, so list/get/create and recording a payment all gate on the same
 * capability contacts use - not a per-feature capability the backend does not grant.
 */
export function canViewLoans(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
